import { Dashboard } from "containers/dashboard/Dashboard";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { CajasCurriculares } from "screens/CajasCurriculares/CajasCurriculares";
import { CajasCurricularesABM } from "screens/CajasCurriculares/CajasCurricularesABM/CajasCurricularesABM";
import { DiseñosCurriculares } from "screens/DiseñosCurriculares/DiseñosCurriculares";
import { PaginaNoEncontrada } from "screens/ErrorScreens/PaginaNoEncontrada";
import Home from "screens/Home/Home";
import { Login } from "screens/Login/Login";
import { Planes } from "screens/Planes/Planes";
import { Usuarios } from "screens/Usuarios/Usuarios";
import { UsuariosProfile } from "screens/Usuarios/UsuariosProfile/UsuariosProfile";
import { UsuariosPendientes } from "screens/UsuariosPendientes/UsuariosPendientes";
import PublicContainer from "../containers/public/PublicContainer";
import { PRIVATE_ROUTE } from "./privateRoutes";
import { PUBLIC_ROUTE } from "./publicRoutes";
import RequireAuth from "components/RequireAuth";
import { PlanesABM } from "screens/Planes/PlanesABM/PlanesABM";
import { Normativas } from "screens/Normativas/Normativas";
import { Modalidad } from "screens/Modalidad/Modalidad";
import { Nivel } from "screens/Nivel/Nivel";
import { Titulos } from "screens/Titulos/Titulos";
import { OpcionPedagogica } from "screens/OpcionPedagogica/OpcionPedagogica";
import { Area } from "screens/Area/Area";
import { Orientaciones } from "screens/Orientaciones/Orientaciones";
import { Certificaciones } from "screens/Certificaciones/Certificaciones";
import { TipoEspacio } from "screens/TipoEspacio/TipoEspacio";
import { EspaciosCurriculares } from "screens/EspaciosCurriculares/EspaciosCurriculares";
import { Ciclo } from "screens/Ciclo/Ciclo";
import { Combinatoria } from "screens/Combinatoria/Combinatoria";
import { CombinatoriaABM } from "screens/Combinatoria/CombinatoriaABM/CombinatoriaABM";
import { Especialidades } from "screens/Especialidades/Especialidades";
import { EspaciosCurricularesABM } from "screens/EspaciosCurriculares/EspaciosCurricularesABM/EspaciosCurricularesABM";
import { ApiScreen } from "screens/Api/ApiScreen";
import { ValidezNacional } from "screens/ValidezNacional/ValidezNacional";
import { OrganismosListPage } from "screens/Organismos/OrganismosListPage";
import { VisorPdfScreen } from "screens/VisorPdf/VisorPdfScreen";
import { PCI } from "screens/PCI/PCI";
import { PCIABM } from "screens/PCI/PCIABM/PCIABM";

const isAuthenticated = () => {
  return !!localStorage.getItem("authToken");
};

const AppRouter = () => {
  const location = useLocation();
  const props = location.state?.props ?? {};

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated() ? (
              <Navigate to={PRIVATE_ROUTE.INICIO} />
            ) : (
              <Navigate to={PUBLIC_ROUTE.LOGIN} />
            )
          }
        />

        <Route element={<PublicContainer />}>
          <Route path={PUBLIC_ROUTE.LOGIN} element={<Login />} />
        </Route>

        <Route path={PRIVATE_ROUTE.API} element={<ApiScreen />} />
        <Route path={PRIVATE_ROUTE.VISOR_PDF + "/:id"} element={<VisorPdfScreen />} />

        <Route element={<Dashboard />}>
          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_HOME */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.INICIO} element={<Home />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.NORMATIVAS} element={<Normativas />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.DISEÑOS_CURRICULARES}
              element={<DiseñosCurriculares />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.PLANES} element={<Planes />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.PLANES_EDITAR + "/:id"}
              element={<PlanesABM abmAction="edit" />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.PLANES_CREAR} element={<PlanesABM />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.PCI} element={<PCI />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.PCI_EDITAR + "/:id"}
              element={<PCIABM abmAction="edit" />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.PCI_CREAR} element={<PCIABM />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.CAJAS_CURRICULARES}
              element={<CajasCurriculares />}
            />
            <Route
              path={PRIVATE_ROUTE.CAJAS_CURRICULARES_CREAR}
              element={<CajasCurricularesABM />}
            />
            <Route
              path={PRIVATE_ROUTE.CAJAS_CURRICULARES_EDITAR + "/:id"}
              element={<CajasCurricularesABM />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.NIVELES} element={<Nivel />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.ESPECIALIDAD}
              element={<Especialidades />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.TITULOS} element={<Titulos />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.ORIENTACIONES}
              element={<Orientaciones />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.OPCION_PEDAGOGICA}
              element={<OpcionPedagogica />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.CERTIFICACIONES}
              element={<Certificaciones />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.USUARIOS} element={<Usuarios />} />
          </Route>
          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.TIPO_ESPACIO}
              element={<TipoEspacio />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.AREA} element={<Area />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.MODALIDAD} element={<Modalidad />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route path={PRIVATE_ROUTE.CICLO} element={<Ciclo />} />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.COMBINATORIA}
              element={<Combinatoria />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.COMBINATORIA_CREAR}
              element={<CombinatoriaABM />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.COMBINATORIA_EDITAR + "/:id"}
              element={<CombinatoriaABM abmAction="edit" />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.USUARIOS_PENDIENTES}
              element={<UsuariosPendientes />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.PERFIL_USUARIOS}
              element={<UsuariosProfile />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.ESPACIOS_CURRICULARES}
              element={<EspaciosCurriculares />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.ESPACIOS_CURRICULARES_CREAR}
              element={<EspaciosCurricularesABM />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                permissions={
                  [
                    /* PERMISOS.VIEW_USER */
                  ]
                }
              />
            }
          >
            <Route
              path={PRIVATE_ROUTE.ESPACIOS_CURRICULARES_EDITAR + "/:id"}
              element={<EspaciosCurricularesABM abmAction="edit" />}
            />
          </Route>
          <Route
            path={PRIVATE_ROUTE.VALIDEZ_NACIONAL}
            element={<ValidezNacional />}
          />
          <Route
            path={PRIVATE_ROUTE.ORGANISMO}
            element={<OrganismosListPage />}
          />
        </Route>
        {/* </Route> */}

        {/* <Route path="*" element={<PaginaNoEncontrada />} /> */}
        {/* <Route path="*" element={<Navigate to={PRIVATE_ROUTE.INICIO} />} /> */}
      </Routes>
    </>
  );
};

export default AppRouter;
